/* eslint-disable react-hooks/exhaustive-deps */

import { Box, Button, Typography, Paper } from '@mui/material';
import { DRAWER_WIDTH_OPEN } from 'styles/theme';
import { withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import React, { useState } from 'react';
import classNames from 'classnames';
import { createVoucher } from 'modules/expenses/store/expenses.actions';
import { POST_VOUCHER_SUMMARY_FAILURE } from 'modules/expenses/store/types';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { showToast } from 'modules/layout/layout.actions';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import { buildCreateVoucherRequest } from 'modules/expenses/vouchers/voucherConstants';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';
import { TRANSFEREE_FAMILY_MEMBER_TYPE_ID } from 'modules/enumerations/enumerationIds';
import ApprovedExpensesComponent from './approvedExpenses.component';
import SubmittedExpensesScreenComonent from './submittedExpensesScreen.comonent';

const styles = theme => ({
  container: {
    height: 'auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    boxSizing: 'border-box',
    maxWidth: '100%',
    whiteSpace: 'normal',
    width: `calc(100% - ${DRAWER_WIDTH_OPEN})`
  },
  headerFixed: { zIndex: 4 },
  estimateHeaderFixed: { paddingTop: '115px', zIndex: 2 }
});

const Expenses = props => {
  const {
    details,
    clients,
    id,
    history,
    enumerations,
    expenseLineItems,
    voucherLineItems,
    recurringPayables,
    approvedLineItems,
    expenseCodes,
    vendors
  } = props;

  const authDetails = details?.authorizationDetails || {};
 
  const employee = details?.familyMembers?.find(s => isIdEqual(s.familyRelationshipTypeId, TRANSFEREE_FAMILY_MEMBER_TYPE_ID)) || {};

  const clientId = authDetails?.clientId || '';

  const authorizationClient = Array.isArray(clients) ? clients.find(c => c.clientRecordId === clientId) : null;
  const clientRecordId = authorizationClient?.clientRecordId;

  const [selectedScreen, setSelectedScreen] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const handleToggle = screen => setSelectedScreen(screen);

  const createVoucher = async (payToVendor) => {
    try {
      setIsLoading(true);

      if (!clientRecordId) {
        props.showToast('Missing client on authorization — cannot create voucher.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return;
      }

      const request = buildCreateVoucherRequest({
        clientId: clientRecordId,
        payToVendor: payToVendor,
        vendorId: payToVendor ? null : null,
        authorizationId: id
      });

      const resp = await props.createVoucher(request);

      if (!resp || resp.type === POST_VOUCHER_SUMMARY_FAILURE) {
        props.showToast('Failed to create new voucher, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return;
      }

      const newId = resp?.response?.voucherId ?? resp?.response?.voucherInformation?.voucherId ?? null;

      if (!newId) {
        props.showToast('Voucher created but no ID returned.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return;
      }

      history.push(`/vouchers/${newId}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box>
      {isLoading && <FullscreenSpinner />}
      {!isLoading && (
        <>
          <Paper square className={classNames('position-fixed', props.classes.headerFixed, props.classes.container)}>
            <Box sx={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', p: '10px', width: '100%' }}>
              <Box sx={{ display: 'flex', flexGrow: 1, justifyContent: 'center', minWidth: 0 }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', p: '10px' }}>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', pt: '20px' }}>
                    <InfoBox label="Authorization Name" value={`${employee?.firstName || ''} ${employee?.lastName || ''}`.trim()} />
                    <InfoBox label="Policy" value={authDetails?.authorizationDetails?.billingPolicyDescription || ''} />
                    <InfoBox label="Status" value="Active" />
                    <InfoBox label="Move Cap" value="$5,000,000,000" />
                    <InfoBox label="Budget Remaining" value="$4,999,998,001" />
                  </Box>
                </Box>
              </Box>
              <Box sx={{ color: 'green', p: '10px', textAlign: 'center' }}>Repay Agreement Received</Box>
            </Box>
          </Paper>

          <Paper square className={classNames('position-fixed', props.classes.estimateHeaderFixed, props.classes.container)}>
            <Box sx={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', p: '10px' }}>
              <Box sx={{ display: 'flex', minWidth: 0 }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', pb: '5px', pl: '20px' }}>
                  <Button
                    color="secondary"
                    variant="contained"
                    sx={{
                      maxHeight: '40px',
                      ml: '12px',
                      mt: '8px',
                      backgroundColor: selectedScreen === 1 ? '#36939b' : '#ffffff',
                      '&:hover': { backgroundColor: selectedScreen === 1 ? '#15585e' : '#faf8f2' },
                      color: selectedScreen === 1 ? 'ffffff' : '#080600'
                    }}
                    onClick={() => handleToggle(1)}
                  >
                    Submitted Expenses
                  </Button>
                  <Button
                    color="secondary"
                    variant="contained"
                    sx={{
                      maxHeight: '40px',
                      ml: '12px',
                      mt: '8px',
                      backgroundColor: selectedScreen === 2 ? '#36939b' : '#ffffff',
                      '&:hover': { backgroundColor: selectedScreen === 2 ? '#15585e' : '#faf8f2' },
                      color: selectedScreen === 2 ? 'ffffff' : '#080600'
                    }}
                    onClick={() => handleToggle(2)}
                  >
                    Approved Expenses
                  </Button>
                </Box>
              </Box>

              <Box sx={{ boxSizing: 'border-box', display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'flex-end', maxWidth: '100%', pb: '5px', pr: '10px' }}>
                <Button
                  color="secondary"
                  variant="contained"
                  sx={{ maxHeight: '40px', mt: '8px' }}
                  onClick={() => createVoucher(false)}
                  disabled={!clientRecordId}
                >
                  Create Voucher
                </Button>
                <Button
                  color="secondary"
                  variant="contained"
                  sx={{ maxHeight: '40px', mt: '8px' }}
                  onClick={() => createVoucher(true)}
                >
                  Create Vendor Invoice
                </Button>
              </Box>
            </Box>
          </Paper>

          <Box sx={{ paddingTop: '185px' }}>
            {selectedScreen === 1 ? (
              <SubmittedExpensesScreenComonent
                voucherLineItems={voucherLineItems}
                expenseLineItems={expenseLineItems}
                recurringPayables={recurringPayables}
                history={history}
                authId={id}
                enumerations={enumerations}
                expenseCodes={expenseCodes}
                transferee={employee}
                vendors={vendors}
                approvedLineItems={approvedLineItems}
              />
            ) : (
              <ApprovedExpensesComponent
                approvedLineItems={approvedLineItems}
                clients={clients}
                enumerations={enumerations}
                id={id}
                history={history}
              />
            )}
          </Box>
        </>
      )}
    </Box>
  );
};

const InfoBox = ({ label, value }) => (
  <Box>
    <Box sx={{ mb: '4px', mr: '20px' }}>
      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
        {label}
      </Typography>
    </Box>
    <Box sx={{ mb: '4px', mr: '20px' }}>
      <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
        {value}
      </Typography>
    </Box>
  </Box>
);

export default compose(
  withStyles(styles),
  connect(null, {
    createVoucher,
    showToast
  })
)(Expenses);
